import firebase from 'firebase/app'
import { HTTP } from '@/http-common'

export default {
  state: {
    loadedStatistics: [],
    statisticsLoading: false
  },
  getters: {
    loadedStatistics (state) {
      return state.loadedStatistics
    },
    statisticsLoading (state) {
      return state.statisticsLoading
    }
  },
  // synchronous
  mutations: {
    setLoadedStatistics (state, payload) {
      state.loadedStatistics = payload
    },
    setStatisticsLoading (state, payload) {
      state.statisticsLoading = payload
    },
    clearLoadedStatistics (state) {
      state.loadedStatistics = []
    }
  },
  // asynchronous
  actions: {
    loadStatistics ({ commit }, payload) {
      commit('clearError')
      commit('setLoading', true)
      commit('setLoadedStatistics', [])

      firebase.auth().currentUser.getIdToken()
        .then(token => {
          HTTP.get('smaai5/statistic?mac=' + payload.mac + '&offset=' + payload.offset + '&limit=25&order=DESC')
          // HTTP.get('smaai5/statistic?mac=' + payload.mac + '&offset=' + payload.offset + '&limit=25&order=DESC',
          //   { headers: { 'Authorization': 'Bearer ' + token } })
            .then(res => {
              console.log(res)
              if (Array.isArray(res.data)) {
                let id = 0
                const _data = res.data.map(function (data) {
                  data.id = id
                  id = id + 1
                  return data
                })
                commit('setLoadedStatistics', _data)
              }
              commit('setLoading', false)
            })
            .catch(err => {
              console.log(err)
              commit('setLoading', false)
              commit('setError', err)
            })
        })
        .catch(err => {
          console.log(err)
          commit('setLoading', false)
          commit('setError', err)
        })
    },
    loadStatisticsWithStatisticsLoading ({ commit }, payload) {
      commit('clearError')
      commit('setStatisticsLoading', true)
      commit('setLoadedStatistics', [])

      firebase.auth().currentUser.getIdToken()
        .then(token => {
          HTTP.get('smaai5/statistic?mac=' + payload.mac + '&offset=' + payload.offset + '&limit=25&order=DESC')
          // HTTP.get('smaai5/statistic?mac=' + payload.mac + '&offset=' + payload.offset + '&limit=25&order=DESC',
          //   { headers: { 'Authorization': 'Bearer ' + token } })
            .then(res => {
              console.log(res)
              if (Array.isArray(res.data)) {
                let id = 0
                const _data = res.data.map(function (data) {
                  data.id = id
                  id = id + 1
                  return data
                })
                commit('setLoadedStatistics', _data)
              }
              commit('setStatisticsLoading', false)
            })
            .catch(err => {
              console.log(err)
              commit('setStatisticsLoading', false)
              commit('setError', err)
            })
        })
        .catch(err => {
          console.log(err)
          commit('setStatisticsLoading', false)
          commit('setError', err)
        })
    },
    clearLoadedStatistics ({ commit }) {
      commit('clearLoadedStatistics')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/statistic/index.js